import { render, staticRenderFns } from "./lilbtn.vue?vue&type=template&id=29a2c880&scoped=true&"
import script from "./lilbtn.vue?vue&type=script&lang=js&"
export * from "./lilbtn.vue?vue&type=script&lang=js&"
import style0 from "./lilbtn.vue?vue&type=style&index=0&id=29a2c880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2c880",
  null
  
)

export default component.exports